<template>
    
	<div>
		<div class="commonBg newsListBg">
			<img :src="banner.pic" alt="">
			<div class="title">
				<span>{{banner.title}}</span>
			</div>
		</div>
		<div :id="maxscrollTop?'commonGoTopNav':''">
			<div class="commonNavBox" >
				<el-breadcrumb separator-class="el-icon-arrow-right">
				  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				  <el-breadcrumb-item :to="{ path: '/news' }">资讯</el-breadcrumb-item>
				  <el-breadcrumb-item>{{type == '1'?'企业动态' :'行业新闻'}}</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
		</div>
		<div class="firstBox" v-if="type=='1'">			
			<ul class="staffList">
				<li class="commonTitleAddMore">
					<div class="newsList">
						<div v-for="(item,index) in articlelist" :key="index" @click="goDetails(item.id)">
							<span>{{item.title}}</span>
							<strong>{{item.update_time}}</strong>
						</div>
					</div>
				</li>
			</ul>
		</div>
		<div class="firmListBox" v-else>
			<div class="firmListItem"  v-for="(item,index) in articlelist" :key="index" @click="goDetails(item.id)">
				<img :src="item.pic" alt="">
				<div class="firmListItemMsg">
					<h2>{{item.title}}</h2>
					<span>{{item.update_time}}</span>
					<p>{{item.vice_title}}</p>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import * as axios from '../../src/axios/api.js'
import imgUrl from '../../src/utils/imgUrl.js'
import * as timeData from '../../src/utils/DataUtils.js'
export default{
	data(){
		return{
			pagefor:'4',
			maxscrollTop:false,
			banner:{},
			articlelist:[],
			type:''
		}
	},
	watch: {
		$route: {
		 handler:  function (val, oldVal){
		   // this.type=val.query.type;
		   this.getnewList(val.query.type);
		 },
		 // 深度观察监听
		 deep:  true
		}
	},
	created() {
		var type=this.$route.query.type;
		// this.type=type;
		this.getnewList(type);
	},
    mounted() {
		window.addEventListener('scroll', this.handleScroll)
    },
	methods:{
		 handleScroll () {
		   var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
		   if(scrollTop > 464){
			   this.maxscrollTop = true
		   }else{
			   this.maxscrollTop = false
		   }
		 },
		 goDetails(article_id){
			 this.$router.push({name:'newListDetail',query: {article_id}});
		 },
		getnewList(type) {
			axios.post('/api/article/articleList',{type:type}).then(res => {
				if(res.code==1){
					this.type=type;
					this.articlelist=res.data.list
					this.banner=res.data.banner[0]
					this.banner.pic=imgUrl.imgUrl(this.banner.pic);
					for(var i in this.articlelist){
						this.articlelist[i].pic=imgUrl.imgUrl(this.articlelist[i].pic);
						this.articlelist[i].update_time=timeData.formatDate(this.articlelist[i].update_time);
					}
				}
			});
		}
	}
}
</script>
<style scoped>
.newsList{border: none; height: auto;}
.commonPageBox {width: 932px;margin: 0 auto;padding-left: 44px;padding-bottom: 50px;}
.firmListBox {width: 932px;margin: 0 auto;padding-left: 44px;padding:60px 0 90px 0;}
.firmListItem {display: flex; align-items: center; margin-bottom: 30px;}
.firmListItem img{width: 180px; height: 120px; margin-right: 24px;}
.firmListItemMsg h2{font-size: 16px;font-weight: bold;color: #000000;line-height: 42px;margin-bottom: 12px;}
.firmListItemMsg span{ font-weight: bold;color: #666666;}
.firmListItemMsg p{ font-size: 14px; color:#666666 ;margin-top: 25px;}
</style>

